import React, { useState, useEffect } from 'react'
import './cardlist.scss'

const CardList = () => {
    const [cardListData, setCardListData] = useState([])

    const getAllRadioButtonsData = async () => {
        try {
            const response = await fetch('data/uielements.json');
            if (!response.ok) {
                throw new Error('Failed to fetch data');
            }
            const data = await response.json();

            const FilterCardList = data.UIElements?.filter((uicode) => uicode.UIElementId === "UIElemetCard");

            setCardListData(FilterCardList || []);

        } catch (err) {
            console.error('Error fetching Radio Buttons data:', err);
        }
    }

    useEffect(() => {
        getAllRadioButtonsData();
    }, []);

    const handleDownload = (file) => {
        if (!file) {
            console.error("Download file path is undefined.");
            return;
        }

        const link = document.createElement('a');
        link.href = file;
        link.download = file.split('').pop(); // safe now
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };


    return (
        <div className="mainCardList">
            <div className="subCardList">
                {
                    cardListData.length === 0 ? (
                        <p>No Data</p>
                    ) : (
                        cardListData.map((item, index) => (
                            <div className="CardList" key={index}>
                                <div className="CardListInfo">
                                    <div className="CardListUIElements-image-box">
                                        <img src={item.VideoGif} alt="" />
                                        <p>{item.developer}</p>
                                    </div>
                                </div>
                                <div className="CardListInfo">
                                    <button className='DownloadBtn' onClick={() => handleDownload(item.DownloadCode)}>Download</button>
                                </div>
                            </div>
                        ))
                    )
                }
            </div>
        </div>
    )
}

export default CardList